import React from "react";

type Props = {};

const PropertyTypeHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <ul className="text-start text-greyDark leading-para">
        <li>
          In this section, the user can select the type of house property as self occupied or deemed
          as let out.
        </li>
        <li>
          As per Income Tax rules, a taxpayer is permitted to report upto 2 house properties as self
          occupied i.e properties purchased for the purpose of using it as ones own residence. If a
          taxpayer has more than 2 house properties that are kept vacant or not rented out, then the
          House Properties in excess of 2 will have to be shown as deemed let out property.
        </li>
        <li>
          Deemed Let Out Property is a property that is primarily acquired for the purpose of
          earning rental income, but it has been kept vacant by the taxpayer, the Income Tax law
          treats such property as deemed to be let out and accordingly the taxpayer is expected to
          show a notional amount as rental income deemed to be earned from such house property and
          the same will be taxed as Income from house property as per the slab rates applicable to
          the taxpayer. Notional rent, refers to the estimated rent that the taxpayer may receive
          from such property even though it is not actually rented out to any person.
        </li>
      </ul>
    </>
  );
};

export default PropertyTypeHint;
